import { ClientContactData } from '@modules/EvaluationModule/interfaces/ClientSubProjectData';
import { CacheEntry } from './types';

/**
 * Which workstreamContactsData bucket(s) a contact belongs to: its real workstream ids,
 * or the pseudo-workstream ("account_<clientId>") bucket when it has none.
 */
export function contactCacheKeysFor(payload: { workstream: string[] | null; clientId: string }): string[] {
  const wsIds = (payload.workstream || []).filter(Boolean);
  return wsIds.length > 0 ? wsIds : [`account_${payload.clientId}`];
}

/**
 * Updates the cached per-workstream contact model in place after an add/edit, instead of
 * refetching: removes the contact from every cache bucket it's currently in, then upserts it
 * into the buckets it now belongs to. Buckets that have not been fetched yet (data: null) are
 * left alone — they'll pick up the contact from a real fetch. fetchedAt is never touched, so a
 * cache's TTL clock keeps running from its last real fetch.
 */
export function applyContactToCaches(
  workstreamContactsData: Record<string, CacheEntry<ClientContactData[]>>,
  contact: ClientContactData,
  keys: string[],
  isMatch: (existing: ClientContactData) => boolean
): void {
  Object.values(workstreamContactsData).forEach((entry) => {
    if (!entry.data) return;
    entry.data = entry.data.filter((existing) => !isMatch(existing));
  });

  keys.forEach((key) => {
    const entry = workstreamContactsData[key];
    if (entry && entry.data) {
      entry.data.push(contact);
    }
  });
}
